import * as React from "react";
import Button from "@components/Button";
import styles from "./vendorsHero.module.scss";
import Image from "next/image";
import { gsap } from "gsap";
import Hero from "@public/assets/images/vendors-hero.png";
//import GSDevTools from "gsap/src/GSDevTools";

const VendorsHero: React.FC = () => {
  let leftRef = React.useRef<Array<HTMLDivElement | null>>([]);
  let rightRef = React.useRef<Array<HTMLDivElement | null>>([]);

  React.useEffect(() => {
    let currentLeftRef = leftRef.current;
    let currentRightRef = rightRef.current;

    gsap.defaults({ ease: "Power4.out" });

    //GSDevTools.create();

    let tl1 = gsap.timeline();

    let tl2 = gsap.timeline();

    tl1.staggerFrom(
      currentLeftRef,
      1.4,
      { delay: 1.8, autoAlpha: 0, y: 100 },
      0.2
    );

    tl2.staggerTo(
      currentRightRef,
      1.4,
      {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        autoAlpha: 1,
        delay: 2.4,
        ease: "expo.out",
      },
      0.4
    );
  }, []);

  return (
    <section className={styles["vendorsHero"]}>
      <div className={styles["vendorsHero__bg"]}>
        <div className={styles["vendorsHero__bg__yellow"]} />
        <div className={styles["vendorsHero__bg__green"]} />
      </div>
      <div className={styles["vendorsHero__container"]}>
        <div className={styles["vendorsHero__left"]}>
          <div className={styles["vendorsHero__left__top__hidden"]}>
            <div
              className={styles["vendorsHero__left__top__text"]}
              ref={(element) => {
                leftRef.current[0] = element;
              }}
            >
              Get the weddings
            </div>
          </div>
          <div className={styles["vendorsHero__left__top__hidden"]}>
            <div
              className={styles["vendorsHero__left__top__text"]}
              ref={(element) => {
                leftRef.current[1] = element;
              }}
            >
              that need you
            </div>
          </div>
          <div className={styles["vendorsHero__left__bottom"]}>
            <div className={styles["vendorsHero__left__bottom__hidden"]}>
              <div
                ref={(element) => {
                  leftRef.current[2] = element;
                }}
                className={styles["vendorsHero__left__bottom__text"]}
              >
                Join to get the best visibility for your business
              </div>
            </div>
            <div className={styles["vendorsHero__left__bottom__hidden"]}>
              <div
                ref={(element) => {
                  leftRef.current[3] = element;
                }}
                className={styles["vendorsHero__left__bottom__text"]}
              >
                and reach a wide range of event onwers
              </div>
            </div>
          </div>

          <div className={styles["vendorsHero__left__button"]}>
            <div
              ref={(element) => {
                leftRef.current[4] = element;
              }}
            >
              <Button
                href={`${process.env.NEXT_PUBLIC_VENDORS_URL}register`}
                newPage
              >
                Become a Vendor
              </Button>
            </div>
          </div>
        </div>
        <div className={styles["vendorsHero__right"]}>
          <div
            className={styles["vendorsHero__right__under"]}
            ref={(element) => {
              rightRef.current[0] = element;
            }}
          ></div>
          <div
            ref={(element) => {
              rightRef.current[1] = element;
            }}
            className={styles["vendorsHero__right__on-top"]}
          >
            <Image
              src={Hero}
              alt="a bride"
              placeholder="blur"
              priority
              quality={100}
              height={433.5}
              width={405.88}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorsHero;
